import { createContext } from 'react';
import type { Dispatch } from 'react';
import type { SaveTaggedMoment } from '@trinity/chat/api/interfaces/transcripts';
import type { TaggedMomentState } from './interfaces';

// Share the edit-params context so TagsCell in shared components can open the modal.
export { SetTaggedMomentEditParamsContext } from '@trinity/chat-components/contexts/tagged-moment';

// The form-state contexts remain app-specific because they carry the full
// TaggedMomentState (including transcript.context which lives in the app).
type CancelSave = (params: SaveTaggedMoment.Request) => void;
export const TaggedMomentFormStateContext = createContext<TaggedMomentState.Value>(null);
export const TaggedMomentFormDispatchContext = createContext<Dispatch<TaggedMomentState.Action>>(null);
export const SaveTaggedMomentContext = createContext<CancelSave>(null);
export const IsSavingTaggedMomentContext = createContext<boolean>(false);
